import fullpage from 'fullpage.js';
import 'fullpage.js/dist/fullpage.css';

document.addEventListener('DOMContentLoaded', function () {
  // fullPage.js の初期化
  new fullpage('#fullpage', {
    licenseKey: 'D1M58-QTZ66-46KMJ-J6U56-RLWOO',
    autoScrolling: true,
    scrollHorizontally: true,
    scrollingSpeed: 1000,
    loopBottom: true,
    scrollBar: false,
    scrollingspeed: 1700,
    easing: 'easeInOutQuart',
    easingcss3: 'cubic-bezier(0.77, 0, 0.175, 1)',

    afterLoad: function (origin, destination, direction) {
      const totalSections = fullpage_api.getActiveSection().item.parentElement.children.length;
      const iconElement = document.getElementById('iconElement');
      if (window.document.body.id === 'p-top') {
        // 3番目、4番目のセクションに到達したとき
        if (destination.index === 2 || destination.index === 3) {
          document.querySelector('.menu-btn').classList.add('wh');

        } else {
          // それ以外のセクションではクラスを削除
          document.querySelector('.menu-btn').classList.remove('wh');
          document.querySelector('.nextSectionButton').classList.remove('wh');
        }

        if (destination.index === 2) {
          document.querySelector('.nextSectionButton').classList.add('wh');
        }
        if (destination.index === 3) {
          document.querySelector('.nextSectionButton').classList.remove('wh');
        }
      };
      // 最後のセクションに到達した場合
      if (destination.index === totalSections - 1) {
        iconElement.setAttribute('xlink:href', '/cms/wp-content/themes/delmonaco2024/assets/images/common/icon_backtop.svg#icon');

      } else {
        // 最後のセクション以外の場合は元のアイコンに戻す
        iconElement.setAttribute('xlink:href', '/cms/wp-content/themes/delmonaco2024/assets/images/common/icon_scroll.svg#icon');
        //document.querySelector('.nextSectionButton').classList.remove('black');
      }
    }
  });

  // 次のセクションへ移動するボタンのイベントリスナー
  document.querySelector('.nextSectionButton').addEventListener('click', function () {
    fullpage_api.moveSectionDown(); // 次のセクションに移動
  });
});

